import { Navigate, useLocation } from 'react-router-dom'

type VenueActivityView = 'visits' | 'breadcrumbs'

interface RedirectToVenueActivityProps {
  view: VenueActivityView
}

const RedirectToVenueActivity = ({ view }: RedirectToVenueActivityProps) => {
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  params.set('view', view)

  return <Navigate to={`/admin/venue-activity?${params.toString()}`} replace />
}

export default RedirectToVenueActivity
